module.exports = __webpack_public_path__ + "70ae79e4efb6119e68bd34d53ae18489.pdf";